<template>
  <m-dialog ref="dlgVerval" :isclose="true" :btnsave="false" :fullscreen="true" title="Informasi Kelas">
    <v-row>
      <v-col cols="12" md="6"
        ><h2 class="font-weight-bold pb-4">Data Profil Peserta</h2>
        <v-row v-if="info && info.info_guru">
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Nama lengkap</p>
            <span>{{ info.name }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">NIK</p>
            <span>{{ info.info_guru.ptk.nik }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">ID SIMPKB</p>
            <span>{{ info.nama }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Alamat Surel</p>
            <span>{{ info.info_guru.belajar_id }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Tanggal Lahir</p>
            <span>{{ info.info_guru.ptk.tgl_lahir }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Usia</p>
            <span>{{ info.usia }} Tahun</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Jenis PTK</p>
            <span>{{ info.info_guru.ptk.m_jenis_ptk ? info.info_guru.ptk.m_jenis_ptk.jenis_ptk : "" }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Mapel yang diampu</p>
            <span>{{ info.info_guru.ptk.m_mapel_ukg ? info.info_guru.ptk.m_mapel_ukg.keterangan : "" }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">NPSN Sekolah</p>
            <span>{{ info.info_guru.sekolah ? info.info_guru.sekolah.npsn : "" }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Jenjang</p>
            <span>{{ info.info_guru.sekolah ? (info.info_guru.sekolah.m_jenjang ? info.info_guru.sekolah.m_jenjang.keterangan : "") : "" }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Asal Sekolah</p>
            <span>{{ info.info_guru.sekolah ? info.info_guru.sekolah.nama : "" }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Lama Mengajar</p>
            <span>{{ info.lama_mengajar }} Tahun</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Provinsi Instansi</p>
            <span>{{ info.kelasenrol[0].kota_sekolah.provinsi.keterangan }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">Kab/Kota Instansi</p>
            <span>{{ info.kelasenrol[0].kota_sekolah.keterangan }}</span>
          </v-col>
          <v-col cols="12" md="6"
            ><p class="font-weight-bold pb-0 mb-0">No Telepon</p>
            <span>{{ info.no_telpon }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6"
        ><h2 class="font-weight-bold pb-4">Berkas Unggahan</h2>
        <v-row v-for="item in berkases.data">
          <v-col cols="1"> <v-icon size="20" color="error">mdi-file-pdf</v-icon></v-col>
          <v-col cols="6">{{ item.nama_berkas }}</v-col>
          <v-col cols="4" class="blue--text" @click="goBerkas(item)">Lihat Berkas</v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <h3>Hasil Pemeriksaan</h3>
        <v-alert
          v-if="info && info.kelasenrol && info.kelasenrol[0]"
          prominent
          icon="mdi-information"
          text
          :type="info.kelasenrol[0].is_complete ? 'success' : 'warning'"
          class="my-2"
        >
          <span class="black--text text-sm"
            >Verifikasi Data dan Berkas Peserta <strong>{{ info.kelasenrol[0].is_complete ? "DITERIMA" : "DITOLAK" }}</strong> oleh
            <strong>{{ info.kelasenrol[0].completedby.name }}</strong>
          </span>
          <p class="black--text text-sm" v-if="info.kelasenrol[0].is_complete == 0">
            Dengan catatan {{ info.kelasenrol[0].keterangan }}. Anda bisa melakukan verifikasi ulang melalui tombol dibawah ini
          </p>
        </v-alert>
        <p clas>Berikan penilaian pada kelengkapan dan keabsahan dokumen ini, Apakah semua dokumen sah dan sesuai dengan yang diinputkan kandidat?</p>
        <m-button
          class="mx-1"
          color="green"
          outlined
          :small="$vuetify.breakpoint.smAndDown ? true : false"
          textButton="Diterima"
          icon=""
          action="setuju"
          @setuju="approval(1)"
        ></m-button>
        <m-button
          class="mx-1"
          color="error"
          outlined
          :small="$vuetify.breakpoint.smAndDown ? true : false"
          textButton="Ditolak"
          icon=""
          action="tolak"
          @tolak="approval(0)"
        ></m-button>
      </v-col>
      <v-col cols="12">
        <v-textarea
          outlined
          autocomplete="false"
          name="Catatan Verval"
          placeholder="Isikan Catatan Verval"
          label="Catatan Verval"
          v-model="keterangan"
          persistent-hint
        ></v-textarea>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
import addDays from "date-fns/add_days";
import subDays from "date-fns/sub_days";
import format from "date-fns/format";

export default {
  components: {},
  provide() {
    return { parentValidator: this.$validator };
  },
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      dialog: false,
      keterangan: null,
      info: {
        nama: "",
        keterangan: "",
        tanggal_mulai: "",
        tanggal_selesai: ""
      },
      berkases: [],
      defInfo: {
        nama: "",
        keterangan: "",
        tanggal_mulai: "",
        tanggal_selesai: ""
      },
      agreed: false
    };
  },

  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.info = obj ? obj : this.defInfo;
      this.keterangan = obj.keterangan;
      this.dialog = true;
      this.loadBerkas(obj);
      let x = this.$refs.dlgVerval.open();
      this.$validator.reset();
      return x;
    },

    loadBerkas(user) {
      var params = {
        user_id: user.id
      };
      return this.$store
        .dispatch("kelas/getBerkas", {
          instansi_id: this.instansi_id,
          params: params
        })
        .then(res => {
          this.berkases = res;
        })
        .catch(e => e);
    },

    goBerkas(val) {
      window.open(val.sasaran[0].url, "_blank");
    },

    approval(val) {
      if (val == 0 && !this.keterangan) {
        this.$error("Wajib mengisi keterangan atau catatan verval");
      } else {
        this.$confirm(`Apakah Anda yakin dengan verifikasi Anda ?`)
          .then(() => {
            return this.$store
              .dispatch("kelas/vervalPeserta", {
                kelas_enrol_id: this.info.kelasenrol[0].id,
                is_complete: val,
                keterangan: this.keterangan
              })
              .then(res => {
                if (res.error) {
                  this.$error("Verval Peserta gagal");
                } else {
                  this.keterangan = null;
                  this.$info("Verval Peserta berhasil");
                  this.$refs.dlgVerval.resolve();
                }
              });
          })
          .catch(e => e);
      }
    }
  }
};
</script>
<style>
.timepicker {
  color: rgba(0, 0, 0, 0.87);
  padding: 9px 8px 9px;
  max-width: 100%;
  width: 100%;
  border: 1px solid grey;
  outline: 1px;
  background: transparent;
  border-radius: 4px;
}

.vdatetime-input {
  width: 500px;
}
</style>
